import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormFieldComponent} from "./form-field.component";
import {MatFormFieldModule} from "@angular/material/form-field";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        MatFormFieldModule,
    ],
    declarations: [
        FormFieldComponent,
    ],
    exports: [
        FormFieldComponent,
    ],
})
export class FormFieldModule {}